module.exports = __webpack_public_path__ + "img/card-logos.2d18fa33.png";